import React from 'react'
import { ModalContainer } from '@components/Modals/ModalContainer'
import { useMyMembershipStatus } from '@components/Web3/RenewMembership/hooks/useMyMembershipStatus'
import { Button, Stack, Text } from '@ui'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { useSpaceIdFromPathname } from 'hooks/useSpaceInfoFromPathname'
import { ButtonSpinner } from 'ui/components/Spinner/ButtonSpinner'
import { SpaceAddressFromSpaceId, useGetSingleSubscription } from 'use-towns-client'
import { Address } from 'viem'

import { useNavigateToSubscription } from '../Web3/Subscriptions/hooks/useNavigateToSubscription'

export const ConfirmLeaveWithSubscriptionCheck = (props: {
    onConfirm: () => void
    onCancel: () => void
    text?: string
    isLoading?: boolean
}) => {
    const { onConfirm, onCancel, text, isLoading = false } = props
    const { data: myAddress } = useMyAbstractAccountAddress()
    const spaceId = useSpaceIdFromPathname()

    const { data: membershipStatus } = useMyMembershipStatus({ spaceId })

    const { data: subscription, isLoading: isLoadingSubscription } = useGetSingleSubscription({
        walletAddress: myAddress ?? '',
        spaceAddress: SpaceAddressFromSpaceId(spaceId ?? '') as Address,
        tokenId: membershipStatus?.tokenId ?? '',
    })
    const navigateToSubscription = useNavigateToSubscription()

    return (
        <ModalContainer minWidth="300" maxWidth="400" onHide={onCancel}>
            <Stack centerContent padding="sm" gap="lg" minHeight="150">
                {isLoadingSubscription ? (
                    <ButtonSpinner />
                ) : subscription?.active ? (
                    <>
                        <Text fontWeight="strong">{text}</Text>
                        <Text>
                            You have an active subscription for this town. You will need to cancel
                            it before leaving.
                        </Text>
                        <Stack horizontal gap>
                            {!isLoading && (
                                <Button tone="level2" onClick={onCancel}>
                                    Cancel
                                </Button>
                            )}
                            <Button
                                tone="negative"
                                disabled={isLoading}
                                onClick={() => {
                                    if (spaceId) {
                                        navigateToSubscription(spaceId)
                                    }
                                }}
                            >
                                View Subscription
                            </Button>
                        </Stack>
                    </>
                ) : (
                    <>
                        <Text fontWeight="strong">{text}</Text>
                        <Text>Are you sure you want to leave?</Text>
                        <Stack horizontal gap>
                            {!isLoading && (
                                <Button tone="level2" onClick={onCancel}>
                                    Cancel
                                </Button>
                            )}
                            <Button tone="negative" disabled={isLoading} onClick={onConfirm}>
                                {isLoading ? 'Leaving' : 'Confirm'}
                            </Button>
                        </Stack>
                    </>
                )}
            </Stack>
        </ModalContainer>
    )
}
